var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnlineLog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 0C15.67 0 0 15.67 0 35C0 54.33 15.67 70 35 70C54.33 70 70 54.33 70 35C70 15.67 54.33 0 35 0ZM35 66.25C17.74 66.25 3.75 52.2588 3.75 35C3.75 17.7388 17.74 3.75 35 3.75C52.26 3.75 66.25 17.7388 66.25 35C66.25 52.2588 52.26 66.25 35 66.25Z",
    fill: "#898989"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.334 68.334C63.8568 68.334 68.334 63.8568 68.334 58.334C68.334 52.8111 63.8568 48.334 58.334 48.334C52.8111 48.334 48.334 52.8111 48.334 58.334C48.334 63.8568 52.8111 68.334 58.334 68.334Z",
    fill: "#898989"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.334 65.834C62.4761 65.834 65.834 62.4761 65.834 58.334C65.834 54.1918 62.4761 50.834 58.334 50.834C54.1918 50.834 50.834 54.1918 50.834 58.334C50.834 62.4761 54.1918 65.834 58.334 65.834Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M58.334 63.334C61.0954 63.334 63.334 61.0954 63.334 58.334C63.334 55.5726 61.0954 53.334 58.334 53.334C55.5726 53.334 53.334 55.5726 53.334 58.334C53.334 61.0954 55.5726 63.334 58.334 63.334Z",
    fill: "#8EC549"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35 32C36.6569 32 38 33.3431 38 35C38 35.75 37.73 36.41 37.295 36.935L42.05 50H38.855L35 39.395L31.145 50H27.95L32.705 36.935C32.27 36.41 32 35.75 32 35C32 33.3431 33.3431 32 35 32ZM35 29C31.6863 29 29 31.6863 29 35C29 35.75 29.15 36.5 29.42 37.19L28.1 40.79C26.795 39.215 26 37.205 26 35C26 30.0294 30.0294 26 35 26C37.3869 26 39.6761 26.9482 41.364 28.636C43.0518 30.3239 44 32.6131 44 35C44 37.205 43.205 39.215 41.9 40.79L40.58 37.19C40.85 36.5 41 35.75 41 35C41 31.6863 38.3137 29 35 29ZM35 23C28.3726 23 23 28.3726 23 35C23 38.54 24.5 41.75 26.96 43.91L25.88 46.91C22.31 44.165 20 39.845 20 35C20 26.7157 26.7157 20 35 20C38.9782 20 42.7936 21.5804 45.6066 24.3934C48.4196 27.2064 50 31.0218 50 35C50 39.845 47.69 44.165 44.12 46.91L43.04 43.91C45.5 41.75 47 38.54 47 35C47 28.3726 41.6274 23 35 23Z",
    fill: "#898989"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnlineLog);
export default __webpack_public_path__ + "static/media/onlineLog.05b07a97af6ed93230383d7f748832fc.svg";
export { ForwardRef as ReactComponent };